import { getCookie } from './getCookie';

export const parseAttributionParams = () => {
  try {
    const fbClickId = getCookie('_fbc');
    const ttClickId = getCookie('ttclid');
    const fbPixelId = getCookie('_fbp');
    const ttPixelId = getCookie('_ttp');
    const utmParams = JSON.parse(localStorage.getItem('utm_params') ?? '{}');

    const params: Record<string, string> = {};

    if (fbClickId) params.fbClickId = fbClickId;
    if (ttClickId) params.ttClickId = ttClickId;
    if (fbPixelId) params.fbPixelId = fbPixelId;
    if (ttPixelId) params.ttPixelId = ttPixelId;
    if (utmParams) params.utm_params = utmParams;

    return params;
  } catch (e) {
    return {};
  }
};
